import React, { useEffect, useRef } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import ModalCustom from '../../../modal-custom'

import { Controller, useForm } from 'react-hook-form'
import DatepickerCustom from '../../../datepicker-custom'
import SwalCustom from '../../../../alert/swal-custom'
import moment from 'moment'
import {
  deleteEjipMemberAPI,
  updateEjipMemberAPI
} from '../../../../services/ejip'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import Error_500 from '../../../error/error-500'
import useNumberInput from '../../../../helper/input-fix-num'

export default function MedalEditMember({
  isModalOpen,
  handleCancel,
  detail,
  fnEffectData
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({})

  useEffect(() => {
    setValue('Deducted', detail?.percentage)
    setValue('ResignationDate', detail?.resignation_date)
  }, [detail, setValue])

  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  const onSubmitEdit = async (d) => {
    try {
      const body = {
        memberId: detail.member_id,
        per: d.Deducted,
        closeDate: d.ResignationDate
      }
      const resp = await updateEjipMemberAPI(body)
      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: 'Success!',
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnEffectData()
          handleCancel()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const onDeleteMemmber = async (memberId) => {
    try {
      const resp = await deleteEjipMemberAPI({ memberId })
      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: 'Success!',
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnEffectData()
          handleCancel()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }
  return (
    <ModalCustom open={isModalOpen} centered onCancel={handleCancel}>
      <Col xl={12}>
        <Row>
          <Form onSubmit={handleSubmit(onSubmitEdit)}>
            <div className="row">
              <div className="fw-normal col-6 p-4">
                <div className="p-1"> % Deducted</div>
                <Controller
                  name={`Deducted`}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <Form.Control
                      onKeyDown={handleKeyDownNum}
                      type="number"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </div>
              <div className="fw-normal col-6  p-4">
                <div className="p-1">Resignation Date</div>
                <Controller
                  name={`ResignationDate`}
                  control={control}
                  render={({ field: { value = '' } }) => (
                    <DatepickerCustom
                      value={value}
                      onChange={([date]) => {
                        setValue(
                          'ResignationDate',
                          `${date ? moment(date).format('YYYY-MM-DD') : ''}`
                        )
                        setError('ResignationDate', date)
                      }}
                    />
                  )}
                />
              </div>
              <div className="col-12 mt-4 d-flex gap-3 justify-content-center">
                <Button
                  variant="outline-primary"
                  style={{
                    width: '130px'
                  }}
                  onClick={handleCancel}
                  size="sm"
                  className="rounded-3"
                >
                  Cancel
                </Button>

                <Button
                  variant="danger"
                  style={{
                    width: '130px'
                  }}
                  size="sm"
                  className="rounded-3"
                  onClick={() => {
                    SwalCustom({
                      title: 'Are you sure?',
                      text: 'Do you want to delete this?',
                      icon: 'question',
                      confirmButtonColor: '#2C5DFE',
                      showCancelButton: true,
                      confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        onDeleteMemmber(detail.member_id)
                      }
                    })
                  }}
                >
                  Delete
                </Button>

                <Button
                  className="btn btn-primary rounded-3"
                  type="submit"
                  style={{
                    width: '130px'
                  }}
                  size="sm"
                >
                  Update
                </Button>
              </div>
            </div>{' '}
          </Form>
        </Row>
      </Col>
    </ModalCustom>
  )
}
